import { secureGet, securePost, secureDelete } from "../../Config/ApiConfig";

/**
 * Request a new data export
 * @returns {Promise} - The created export with its ID for tracking progress
 */
export const requestDataExport = async () => {
    const { data } = await securePost('/data-exports', {});
    return data;
};

/**
 * Get the list of previous data exports with pagination
 * @param {Object} params - Pagination parameters
 * @param {number} params.page - Page number
 * @param {number} params.per_page - Number of items per page
 * @returns {Promise} - List of exports and pagination metadata
 */
export const getPreviousExports = async ({ page, per_page }) => {
    const { data } = await secureGet(`/data-exports?page=${page}&per_page=${per_page}`);
    return data;
};

/**
 * Delete a data export
 * @param {string} exportId - ID of the export to delete
 * @returns {Promise} - Result of the deletion operation
 */
export const deleteExport = async (exportId) => {
    const { data } = await secureDelete(`/data-exports/${exportId}`);
    return data;
};

/**
 * Update consent preferences
 * @param {Object} consents - Consent settings
 * @returns {Promise} - Updated consent information
 */
export const updateConsents = async (consents) => {
    const { data } = await securePost('/settings/consents', consents);
    return data;
};

/**
 * Delete the current user's account
 * @returns {Promise} - Result of the account deletion operation
 */
export const deleteAccount = async () => {
    const { data } = await secureDelete('/users/me');
    return data;
};